module.exports = __webpack_public_path__ + "static/vtf_hngl-webfont-9951181601faed3c809e72f27c4a4a99.woff";